<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingT16">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey20 fWeight600">个人信息</div>
                        <div style="width: 16px;">
                            <!--<i class="icon closeIcon" @click="close()"></i>-->
                        </div>
                    </div>
                </header>
                <div class="body" style="margin-top: 10px; padding-bottom: 34px;">

                    <div class="marginT24" style="padding-bottom: 34px">
                        <form class="form" action="javascript:;">
                            <div class="formRow" v-for="infoItem in infoList">
                                <label class="formLabel block">
                                    {{infoItem.field}}
                                </label>
                                <div class="formData marginT16 font18r">
                                    {{infoItem.value}}
                                </div>
                            </div>
                            <div class="optArea" style="margin-top: 70px; padding: 0 39px;">
                                <button class="button closeButton font16r fl bold" @click="close()">关闭</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import drawerPart from "../part/drawerPart";

    // api
    import seekerApi from '@comp/humanResources/seekerApi';

    // util
    import appHelper from "@util/appHelper";
    import consoleHelper from "@util/consoleHelper";
    import objectHelper from "@util/objectHelper";

    // platformApi
    import requestManager from "@comp/platformApi/requestManager.js";

    const config = {

    };

    export default {
        name: "contactInfoDrawer",
        extends: drawerPart,
        props: {
            infoList: {
                type: Array
            },
        }
    };
</script>

<style lang="scss" scoped>
    .header {
        .closeIcon {
            width: 14px;
            height: 14px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACD0lEQVRIibWWP26jQBTGp3LKeLchrRHeCM0fkKNEcjXSVr7AHMBNbsAN0uUicRSOEEdabUdjfIFIaEQFuBkkCpuXYnGUtWeAZL1PetWI3zfzvTfzQKglHMc5I4RYruuO6Z+4apK6rjsmhFiO45y1MYxgSqmNMb72PO+mLTHG15RSu7cQxvg7pfSqC3yYzcm+dcEv+uy67TQY4wst3Pf94b/AP4r4vj/Uef5pW9rs+qsmlFL7VPB9MsZGe98HOmvCMLyN4/i+CxTH8X0YhreGegwQIcTSfZhl2RIA6iRJHkxwKeUDANRZlr3o1gkhFvI874duMQiCWVVVrwBQSymPRJIkWQBAXVXVaxAEMx3Ddd0xopRS0w5NIn3gTbEpYoxN2jwOgmBWluW6sWshpVwAwK4sy/V8Pv/ZUehJp4DneTdCCK6UWgNADQC1UmothOA9OmnSatE+OefToiiW0ERRFEvO+bTHfaCIMXbZBc/z/BkAdkqpWCkVA8Auz/PnLhHG2KWxTTXwlRCCN3at+ogQQizjReOcT7MsewGA7R5+UJMVAGxNdr1fNIQQYoyNDH2+LYril66gQgi+2Wx+A8BOSvmosWf08ZkeHHZTFEV3aZo+tVnAOZ+mafoURdHdYfe8734ftm2fn+q5tm37/L8NHEKI1TrVfN8ffnVkHg0aU2CMB58Z+oyx0ZHnfeIUvy1vjeomB0FzNDwAAAAASUVORK5CYII=');
        }
    }

    .warnIcon {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACCUlEQVRIiZVWIXLjQBBcEHAPyANcFf8grkrggQMHrir3hDwgVQHy9u7OOhXxAwfuAQJ+QKBBgICfYSBoECgQENAHdi3LsbTaCKmknume1uyMlEpcXOkrCgo6vaFDQ8E7BS0dGjq9oaDgSl+lciQS64oCUkA67OlNTTEVxVT0pqbDvnsvusomojd3FLQUfFBMReB2FAvcBlKQgpbe3KWTi3mM4B09FtkVeywo2IVY85hSTorZsiguB8iDUm/qwfiiuKSYbcScVkJr59GW3VDyqPJfiuBIgh0FLa2d99VXFHykbKHgeYogCllEXNVXT0p8MEUgeEnhAjbaae1cUVBQwFS3hCB9nyNEqUN3gRQUis680mE/rSoSOP1nChvxb/TYKAqaKV+VUop2+SOqes4i8KamoFHh+GeUvbLfg694yKvArClo8wm6ZtD3XyXItMjOQgX6ZxZBZ5Ezr/R6+iOX5QWtnbEsv+VVcPzIWW0aSfKSn7TpwVs/cdAOo8LpmmV5kcb2DlooJ46KJ3s9GiTmvZv//TnzGfdkr88OZN6wM39DBWa0gk/Dbnb60uF3VDg4rqeumHwbbfw1DOovnIRdZ3HBll3cgsMLpwOHStpu17rlzTh2edPb3e2o8rNAa+e9XUs6vafTNUWvKXod79+OS99UZ57nE6Ggx4aCJlbWhtOP8NuS6CillPoP4lk4kl8eIhoAAAAASUVORK5CYII=);
    }

    .form {

        .formRow {
            padding: 24px 0 12px;
            border-bottom: solid 1px rgba(240, 240, 240, .76);
        }
        .formLabel {
            color: rgba(91, 97, 108, 1);
        }
        .formData {
            color: rgba(51, 51, 51, 1);
        }

        /* opeartion area */
        .optArea {
            .button {
                height: 42px;
                line-height: 42px;
                border-radius: 18px;
                padding: 0;
                display: block;
                width: 100%;

                &.closeButton {
                    background: #f7f7f7;
                    color: black;
                    border: none;
                }
            }
        }
    }
</style>
